import React, { useState } from 'react';
import { Modal, Row, Col, Card, Form, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faDollarSign,
  faChartLine,
  faChartPie,
  faTable,
  faStar,
  faMap,
  faBrain
} from '@fortawesome/free-solid-svg-icons';

const iconMap = {
  users: faUsers,
  'dollar-sign': faDollarSign,
  'trending-up': faChartLine, // FontAwesome 5 no tiene faTrendingUp, usar faChartLine
  'chart-line': faChartLine,
  'chart-pie': faChartPie,
  table: faTable,
  star: faStar,
  map: faMap,
  brain: faBrain
};

const categoryColors = {
  kpi: 'primary',
  chart: 'success',
  table: 'info',
  map: 'warning',
  ai: 'danger'
};

/**
 * Componente modal que muestra la librería de widgets disponibles
 */
const WidgetLibrary = ({ show, onHide, availableWidgets = [], onAddWidget }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Asegurar que availableWidgets sea un array
  const safeAvailableWidgets = Array.isArray(availableWidgets) ? availableWidgets : [];

  // Filtrar widgets por búsqueda y categoría
  const filteredWidgets = safeAvailableWidgets.filter(widget => {
    const matchesSearch = widget.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         widget.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || widget.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // Obtener categorías únicas
  const categories = ['all', ...new Set(safeAvailableWidgets.map(w => w.category))];

  const handleAddWidget = (widgetType) => {
    onAddWidget(widgetType);
  };

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon={faBrain} className="me-2" />
          Librería de Widgets
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Filtros */}
        <Row className="mb-4">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Buscar widgets..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
          <Col md={6}>
            <Form.Select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="all">Todas las categorías</option>
              {categories.filter(c => c !== 'all').map(category => (
                <option key={category} value={category}>
                  {category.toUpperCase()}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        {/* Grid de Widgets */}
        <Row>
          {filteredWidgets.length === 0 ? (
            <Col>
              <div className="text-center text-muted py-5">
                <p>No se encontraron widgets</p>
              </div>
            </Col>
          ) : (
            filteredWidgets.map(widget => (
              <Col key={widget.type} md={6} lg={4} className="mb-3">
                <Card 
                  className="h-100 widget-card"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleAddWidget(widget.type)}
                >
                  <Card.Body>
                    <div className="d-flex align-items-start mb-3">
                      <div 
                        className="widget-icon me-3"
                        style={{
                          width: '48px',
                          height: '48px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '8px',
                          backgroundColor: `var(--bs-${categoryColors[widget.category] || 'secondary'})`
                        }}
                      >
                        <FontAwesomeIcon 
                          icon={iconMap[widget.icon] || faBrain} 
                          size="lg"
                          style={{ color: 'white' }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{widget.name}</h6>
                        <Badge bg={categoryColors[widget.category] || 'secondary'}>
                          {widget.category}
                        </Badge>
                      </div>
                    </div>
                    <p className="text-muted small mb-2">{widget.description}</p>
                    <div className="text-muted small">
                      <span>Tamaño: {widget.defaultSize?.w}x{widget.defaultSize?.h}</span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default WidgetLibrary;

